import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { store } from "@/store";
import { ThemeProvider } from "@context/ThemeContext";
import { AuthInit } from "@context/AuthContext";
import { NotificationProvider } from "@context/NotificationContext";
import { router } from "./routes";
import "@i18n/index";
import "./App.css";

export const App = () => {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <NotificationProvider>
          <AuthInit>
            <RouterProvider router={router} />
          </AuthInit>
        </NotificationProvider>
      </ThemeProvider>
    </Provider>
  );
};
